import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import DashboardLayout from "../../Layout/DashboardLayout";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { get } from "../../utils/api";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import SocialLayout from "../../Layout/SocialLayout";
import Unauthorized from "../../Components/Unauthorized/Unauthorized";
const SocialData = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [pendingData, setPendingData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate(); // Initialize navigate

  // Function to fetch data based on type
  const fetchData = async (type) => {
    setIsLoading(true);
    try {
      const response = await get(`/social/getSocial?type=${type}`);
      if (type === "Pending") {
        setPendingData(response.data.data || []);
      } else if (type === "Completed") {
        setCompletedData(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data whenever activeTab changes
  useEffect(() => {
    const type = activeTab === 0 ? "Pending" : "Completed";
    fetchData(type);
  }, [activeTab]);

  const tableData = activeTab === 0 ? pendingData : completedData;

  const tabStyles = (isActive) => ({
    borderRadius: "10px",
    textTransform: "none",
    backgroundColor: isActive ? "#EB7E0E" : "transparent",
    color: isActive ? "white" : "orange",
    borderColor: "orange",
    "&:hover": {
      backgroundColor: isActive ? "#EB7E0E" : "rgba(24, 77, 128, 0.1)",
      borderColor: "orange",
    },
  });

  const handleNavigate = (id) => {
    navigate(`/social/getSocial`);
  };

  return (
    <MainDashboardLayout sidebar={<SocialLayout />}>
      <Unauthorized requiredModule="Social Dashboard">
        <Box sx={{ paddingTop: "20px", width: "100%" }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            DATA
          </Typography>

          <Box sx={{ mb: 2, display: "flex", gap: 1 }}>
            {["Pending", "Completed"].map((label, index) => (
              <Button
                key={label}
                onClick={() => setActiveTab(index)}
                variant={activeTab === index ? "contained" : "outlined"}
                sx={tabStyles(activeTab === index)}
                style={{
                  backgroundColor: "#EB7E0E",
                }}
              >
                {label}
              </Button>
            ))}
          </Box>

          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper}>
              <Table sx={{ borderCollapse: "collapse" }}>
                <TableHead>
                  <TableRow>
                    {["S.No", "Title", "Create Date", "Status", "Action"].map(
                      (header) => (
                        <TableCell
                          key={header}
                          align="left"
                          sx={{
                            borderRight: "1px solid #E0E0E0",
                            borderBottom: "1px solid #E0E0E0",
                            fontWeight: "bold",
                          }}
                        >
                          {header}
                        </TableCell>
                      ),
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((row, index) => (
                    <TableRow
                      key={row._id} // Ensure unique key, using _id from the response
                      sx={{
                        "& td": {
                          borderRight: "1px solid #E0E0E0",
                          verticalAlign: "middle",
                          padding: "5px",
                        },
                        "&:last-child td": { borderBottom: "none" },
                      }}
                    >
                      <TableCell
                        align="left"
                        sx={{ fontSize: "14px", marginLeft: "10px" }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell align="left" sx={{ fontSize: "14px" }}>
                        {row.title}
                      </TableCell>
                      <TableCell align="left" sx={{ fontSize: "14px" }}>
                        {new Date(row.createdAt).toLocaleDateString()}{" "}
                        {/* Show formatted create date */}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontSize: "14px",
                          color:
                            row.status === "Pending"
                              ? "red"
                              : row.status === "Partially Complete"
                                ? "orange"
                                : "green",
                        }}
                      >
                        {row.status}
                      </TableCell>
                      <TableCell align="left" sx={{ fontSize: "14px" }}>
                        <Button
                          variant="text"
                          sx={{
                            color: "#115293",
                            textTransform: "none",
                            fontSize: "14px",
                            "&:hover": { textDecoration: "underline" },
                          }}
                          onClick={() => handleNavigate(row._id)} // Trigger navigation on click
                        >
                          {row.status === "Pending"
                            ? "Start"
                            : row.status === "Partially Complete"
                              ? "Continue"
                              : "View/Edit"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default SocialData;
